import api from "../utils/api";
import { getFetch } from "./../utils/request";

const syModel = {
  // 初始化
  init: async (data) => {
    const success = await getFetch(api.syInit, data);
    return success;
  },
  // 获取用户拓展
  userInfo: async (url, data) => {
    const success = await getFetch(url, data);
    return success;
  },
  // 注册 ---
  reg: async (url, data) => {
    const success = await getFetch(url, data);
    return success;
  },
  // 登陆 ==
  login: async (url, data) => {
    const success = await getFetch(url, data);
    return success;
  },
  // 获取token
  getToken: async (url, data) => {
    const success = await getFetch(url, data);
    return success;
  },
  // 获取图形验证码 --
  getImage: async (url, data) => {
    const success = await getFetch(url, data);
    return success;
  },
  // 发送邮箱验证码
  sendEmailCode: async (url, data) => {
    const success = await getFetch(url, data);
    // const success = await postFetch(url, data);
    console.log("success==", success);
    return success;
  },
  // 绑定邮箱
  bindEmail: async (url, data) => {
    const success = await getFetch(url, data);
    return success;
  },
  // 检验邮箱是否绑定
  verifyBindEmail: async (url, data) => {
    const success = await getFetch(url, data);
    return success;
  },
  // 校验邮箱验证码
  validEmailCode: async (url, data) => {
    const success = await getFetch(url, data);
    return success;
  },
  // 修改密码
  changePwdEmail: async (url, data) => {
    const success = await getFetch(url, data);
    return success;
  },
  // 綁定郵箱檢驗郵箱是否綁定
  verifyBindEmailA: async (url, data) => {
    const success = await getFetch(url, data);
    return success;
  },
  // 收集设备信息接口
  webDevice: async (data) => {
    const success = await getFetch(api.syWebDevice, data);
    return success;
  },
  // 埋点数据上报接口
  webDot: async (data) => {
    const success = await getFetch(api.syWebDot, data);
    return success;
  },
  // 错误日志上报接口
  webErrorlog: async (data) => {
    const success = await getFetch(api.syWebErrorlog, data);
    return success;
  },
  // 进入游戏
  getGameUrl: async (url, data) => {
    const success = await getFetch(url, data);
    return success;
  },
  // 客服按钮同步登陆
  kfSync: async (url, data) => {
    const success = await getFetch(url, data);
    return success;
  },
  // 应用充值下单接口
  createOrder: async (url, data) => {
    const success = await getFetch(url, data);
    return success;
  },
  // ---------- 手机登陆 ------------
  // 获取手机号码区号列表
  getMobileAreaCode: async (url, data) => {
    const res = await getFetch(url, data);
    return res;
  },
  // 发送手机短信验证码接口
  getMobileSendCode: async (url, data) => {
    const res = await getFetch(url, data);
    return res;
  },
  // 手机短信验证码校验接口接口
  getMobileCheckCode: async (url, data) => {
    const res = await getFetch(url, data);
    return res;
  },
  // 图形验证码token
  getCaptchaToken: async (url, data) => {
    const res = await getFetch(url, data);
    return res;
  },
  // 图形验证码初始化
  getCaptchaInit: async (url, data) => {
    const res = await getFetch(url, data);
    return res;
  },
  // 圖形碼驗證校验
  getCaptchaVerify: async (url, data) => {
    const res = await getFetch(url, data);
    return res;
  },
  // 手机号码格式校验接口
  getMobileFormatVerify: async (url, data) => {
    const res = await getFetch(url, data);
    return res;
  },
};

export default syModel;
